import { TextField } from "@material-ui/core";
import { Alert } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactInputMask from "react-input-mask";
import styled from "styled-components";
import api from "../../../../config/api";
const SuccessAlert = styled(Alert)`
  position: fixed;
  top: 12px;
  width: 600px;
  z-index: 99;
`;
export default function WorkDayHoursForm({ weekDayIndex, weekDayId, startFirst, endFirst, startSecond, endSecond }) {
  const weekDayName = getWeekDay(weekDayIndex);
  const [isSuccessAlertOpen, setIsSuccessAlertOpen] = useState(false);
  const [error, setError] = useState("");
  const [startFirstVal, setStartFirstVal] = useState(startFirst);
  const [endFirstVal, setEndFirstVal] = useState(endFirst);

  const [startSecondVal, setStartSecondVal] = useState(startSecond);
  const [endSecondVal, setEndSecondVal] = useState(endSecond);
  const handleSuccessAlertOpen = () => setIsSuccessAlertOpen(true);
  const handleSuccessAlertClose = () => setIsSuccessAlertOpen(false);
  function getWeekDay(weekDayIndex) {
    let days = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];
    return days[weekDayIndex];
  }

  const handleSubmitWorkDayHour = async () => {
    let object = {
      startFirst: startFirstVal,
      endFirst: endFirstVal,
      startSecond: startSecondVal,
      endSecond: endSecondVal,
    };
    if (!startFirstVal || !endFirstVal) {
      return setError("Prencher todos os campos obrigatorios");
    }
    try {
      const response = await api.put(`/professional-reserve-hours/${weekDayId}`, object);
      // console.log(response.data);
      handleSuccessAlertOpen();
    } catch (e) {
      console.error("WorkDayHoursForm - handleSubmitWorkDayHour");
      console.error(e);
    }
  };
  useEffect(() => {
    if (startFirstVal && endFirstVal) {
      setError("");
    }
  }, [startFirstVal, endFirstVal]);
  return (
    <div className="d-flex flex-column">
      <div className="d-flex mt-2">
        <ReactInputMask mask="99:99" defaultValue={startFirstVal} onChange={(e) => setStartFirstVal(e.target.value)}>
          {() => (
            <TextField
              variant="outlined"
              className="enter-exit-time-input me-3"
              label="Entrada"
              name="startFirst"
              required
              InputLabelProps={{ shrink: true }}
            />
          )}
        </ReactInputMask>
        <ReactInputMask mask="99:99" defaultValue={endFirstVal} onChange={(e) => setEndFirstVal(e.target.value)}>
          {() => (
            <TextField
              name="endFirst"
              variant="outlined"
              className="enter-exit-time-input me-3"
              label="Saída"
              required
              InputLabelProps={{ shrink: true }}
            />
          )}
        </ReactInputMask>
        <ReactInputMask mask="99:99" defaultValue={startSecondVal} onChange={(e) => setStartSecondVal(e.target.value)}>
          {() => (
            <TextField
              name="startSecond"
              variant="outlined"
              className="enter-exit-time-input me-3"
              label="Entrada"
              InputLabelProps={{ shrink: true }}
            />
          )}
        </ReactInputMask>
        <ReactInputMask mask="99:99" defaultValue={endSecondVal} onChange={(e) => setEndSecondVal(e.target.value)}>
          {() => (
            <TextField
              name="endSecond"
              variant="outlined"
              className="enter-exit-time-input me-3"
              label="Saída"
              InputLabelProps={{ shrink: true }}
            />
          )}
        </ReactInputMask>
        <div className="d-flex align-items-center">
          <span onClick={handleSubmitWorkDayHour} type="button" className=" br-6 c-blue-link preference-card-link px-3">
            Aplicar alterações
          </span>
        </div>
      </div>
      <span className="text-cl-red mt-2">{error}</span>
      {isSuccessAlertOpen && <SuccessAlert onClose={handleSuccessAlertClose}>Horário salvo com sucesso!</SuccessAlert>}
    </div>
  );
}
